import Commands from './commands';

class And extends Commands {
    constructor(registry) {
        super("and", registry);
    }

    async execute(node, emitter, options) {
        const param1 = await emitter(node.params[0], options);
        const param2 = await emitter(node.params[1], options);
        return param1 && param2;
    }
}

export default And;
